module.exports = __webpack_public_path__ + "public/img/联系我们.ae73dc8a.png";